import approval from './approval.json';
import approvalFinancial from './approvalFinancial.json';
import approvalListIds from './approval-list-ids.json';
import target from './target.json';
import targetBuyer from './target-buyer.json';

export default {
  approval,
  approvalFinancial,
  approvalListIds,
  target,
  targetBuyer,
};
